import { render, staticRenderFns } from "./user-ticket.vue?vue&type=template&id=c4fa9532"
import script from "./user-ticket.vue?vue&type=script&lang=js"
export * from "./user-ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports